
  import { hasPermission, Permissions } from '@/ui/auth/auth';
  import { ChecklistCreateButton } from '@/ui/pages/checklist/ChecklistCreateButton';
  import EmptyStateEntry from '@/ui/pages/EmptyStateEntry';
  import { defineComponent } from 'vue';

  export default defineComponent({
    components: {
      ChecklistCreateButton,
      EmptyStateEntry,
    },
    setup() {
      const canManageChecklists = hasPermission(Permissions.MANAGE_CHECKLISTS);

      return {
        canManageChecklists,
      };
    },
  });
